import { dataBrush } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBrush = /*#__PURE__*/createIcon(dataBrush)
export default IconBrush
